module.exports = __webpack_public_path__ + "img/Groupe 86.72ebafaf.svg";